
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { PreviousRouteService } from 'src/app/core/services/previous-route.service';
import { UserService } from 'src/app/core/user/user.service';
import { QueueService } from 'src/app/queue/queue/queue.service';
import { ProfileService } from '../services/profile.service';
import { NavigationService } from 'src/app/core/services/navigation.service';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { JoinQueueRequest } from 'src/app/core/models/JoinQueueRequest';
import { User } from 'src/app/core/user/user.model';
import { SessionStorageService } from 'src/app/shared/storage/session-storage.service';

@Component({
  selector: 'app-setup-password',
  templateUrl: './setup-password.component.html',
  styleUrls: ['./setup-password.component.scss']
})
export class SetupPasswordComponent implements OnInit, OnDestroy {
  setupPw$: Subscription;
  isQueue: boolean = false;
  user: User;
  showPw: boolean = false;

  fgroup: UntypedFormGroup = this.fb.group({
    password: ['', [Validators.required, Validators.minLength(8)]],
  });

  constructor(
    private profileService: ProfileService,
    private previousRouteService: PreviousRouteService,
    private userService: UserService,
    private queueService: QueueService,
    private navigationService: NavigationService,
    private fb: UntypedFormBuilder,
    private sessionStorageService: SessionStorageService,
  ) { }

  get fg() { return this.fgroup; }

  get f() { return this.fg.controls; }

  ngOnInit(): void {
    this.user = this.userService.getCustomer();

    // check if queueData exists in session storage
    let queueData = this.queueService.getQueueData();
    this.isQueue = queueData ? true : false;

    this.setupPw$ = this.userService.setupPw.subscribe(async (newPassword: string) => {
      await this.profileService.onUpdatePassword("", newPassword);

      let route = this.previousRouteService.getPreviousRoute().routeName;
      this.previousRouteService.removePreviousRoute();
      this.navigationService.navigateByUrl(route, { replaceUrl: true, state: { reinit: true } });
    });
  }

  async onSkip() {
    if (this.isQueue) {
      // get join request from session storage
      let queueRequest = {} as JoinQueueRequest;
      queueRequest = JSON.parse(this.sessionStorageService.getItem("queueRequest"));
      await this.queueService.onJoinQueueInit(queueRequest);
    }
    else {
      this.goToPreviousRoute();
    }
  }

  goToPreviousRoute() {
    let route = this.previousRouteService.getPreviousRoute().routeName;
    this.previousRouteService.removePreviousRoute();
    this.navigationService.navigateByUrl(route, { replaceUrl: true, state: { reinit: true } });
  }


  async onSubmit() {
    if (this.fg.invalid) {
      return;
    }

    if (this.isQueue) {
      // get join request from session storage
      let queueRequest = {} as JoinQueueRequest;
      queueRequest = JSON.parse(this.sessionStorageService.getItem("queueRequest"));
      await this.profileService.onUpdatePassword("", this.fgroup.value['password']);
      await this.queueService.onJoinQueueInit(queueRequest);
    }
    else {
      this.userService.setupPw.next(this.fgroup.value['password']);
    }
  }

  ngOnDestroy(): void {
    this.setupPw$.unsubscribe();
  }

}
